import API from '../../lib/api'
import base from './base'

const api = new API(1, 'tasks')
const baseModule = base(api);

export default {
	namespaced: true,
	state: baseModule.state,
	getters: baseModule.getters,
	actions: baseModule.actions,
	mutations: baseModule.mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/tasks.js